export default __webpack_public_path__ + "static/media/health-icon.e684a65a.svg";